export const environment = {
  production: false,
  API_END_POINT: 'https://dev.docquityclinic.com',
  indonesiaDomain: 'https://dev.docquitycare.id',
  otherDomain: 'https://dev.docquitycare.com',
  hCaptchaSiteKey: '10000000-ffff-ffff-ffff-000000000001',
  env : 'DEV',
  hideRelevantFilesPharma: 'PHM408'
};
